module.exports = __webpack_public_path__ + "img/image8.05eb5ba2.png";